import * as React from "react";
import { createContext, useReducer } from 'react';
import type { IAppState } from "models";
import { Actions } from "reducer/actions";
import { initialState } from "reducer/initialState";
import { appReducer } from "reducer";



const AppContext = createContext<{ state: IAppState, dispatch: React.Dispatch<Actions> }>(
    {
        state: initialState(),
        dispatch: () => null
    });


const AppProvider = ({ children }) => {
    const [state, dispatch] = useReducer(appReducer, initialState());

    return (
        <AppContext.Provider value={{ state, dispatch }}>
            {children}
        </AppContext.Provider>
    )
}



export { AppContext, AppProvider };

